import axios from 'axios';
import properties from '../../properties';
import {
  BuildScenarioRowResult,
  TableType,
} from '../../../pages/FinancialForensicsPage/FinancialForensics.types';
import { FixedCostFeeCalculation } from '../../../pages/FinancialForensicsPage/types/FixedCost.types';

export const addScenarios = async (
  egNid: string,
  scenarioInfo: { name: string; notes?: string },
  createdBy: string,
  planStartDate: string,
  planEndDate: string,
  totalFixedCost: number,
  totalVariableCost: number,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.addScenarios,
      {
        egNid,
        scenarioName: scenarioInfo?.name?.trim(),
        notes: scenarioInfo?.notes?.trim(),
        createdBy,
        planStartDate,
        planEndDate,
        totalFixedCost,
        totalVariableCost,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        handleOpenSnackBar('Scenario added successfully', 'success', 1000);
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const fetchScenarios = async (
  egNid: string,
  planStartDate?: string,
  planEndDate?: string,
  pageNumber?: number,
  pageSize?: number,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.getScenarios,
      {
        egNid,
        pageNumber,
        pageSize,
        planStartDate,
        planEndDate,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const deleteScenario = async (id: string, handleOpenSnackBar?: any) => {
  try {
    const response = await axios.delete(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        `/scenario/${id}`,
    );
    handleOpenSnackBar('Scenario deleted successfully', 'success', 2000);
    return response;
  } catch (error: any) {
    handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    return null;
  }
};

export const duplicateScenario = async (
  id: string,
  handleOpenSnackBar?: any,
) => {
  try {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.duplicateScenario,
      {
        id,
      },
    );
    handleOpenSnackBar('Scenario duplicated successfully', 'success', 2000);
    return response;
  } catch (error: any) {
    handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    return null;
  }
};

export const fetchBuildScenario = async (
  egNid: string,
  scenarioId: string,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.getBuildScenario,
      {
        egNid,
        scenarioId,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.message, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const saveBuildScenario = async (
  egNid: string,
  scenarioId: string,
  fixedCost: any,
  variableCost: any,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        properties.addBuildScenario,
      {
        egNid,
        scenarioId,
        fixedCost,
        variableCost,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.message, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};

export const updateBuildScenario = async (
  egNid: string,
  scenarioId: string,
  vendorId: string,
  serviceId: string,
  feeCalculation?: FixedCostFeeCalculation,
  totalFee?: number,
  capFee?: number,
  flatFee?: number,
  type?: BuildScenarioRowResult,
  tableType?: TableType,
  handleOpenSnackBar?: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.financialForensicsBaseURL +
        '/update-build-scenario',
      {
        egNid,
        scenarioId,
        vendorId,
        serviceId,
        feeCalculation,
        capFee,
        flatFee,
        totalFee,
        type,
        tableType,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.message, 'error', 6000);
      return null; // Return null or an appropriate value in case of an error
    });
};
